<script lang="ts" setup>
  import { RELATED_WORK_ASSETS } from './constants'

  defineProps<{
    visible: boolean
  }>()

  const emit = defineEmits<{
    close: []
  }>()
</script>

<template>
  <Teleport to="body">
    <div v-if="visible" class="related-work-tip-overlay" @click.self="emit('close')">
      <div class="related-work-tip-modal">
        <div class="related-work-tip-header">
          <span class="related-work-tip-title">关联作品规则介绍</span>
          <button type="button" class="related-work-tip-close" @click="emit('close')">
            <img :src="RELATED_WORK_ASSETS.popupCloseIcon" alt="关闭" />
          </button>
        </div>
        <div class="related-work-tip-body">
          <p>
            1）
            在该面板选中的作品，为原作品；关联了原作的作品获得想要后，数据会同步至原作品，让原作品更快集齐想要上架
          </p>
          <p>
            2）
            原作品集齐想要并上架后，关联了原作的作品，也会展示原作商品链接，可以持续给该商品导流哦~
          </p>
        </div>
        <div class="related-work-tip-footer">
          <button type="button" class="related-work-tip-confirm" @click="emit('close')">
            知道了～
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style lang="stylus" scoped>
  @import './relatedWork.styl'
</style>
